export default "__VITE_ASSET__903a65ca__"